import { Loader2 } from "lucide-react";

import { Button, type ButtonProps } from "@/components/ui/button";

interface SubmitButtonProps extends ButtonProps {
  pending: boolean;
  pendingText: string;
}

// Disabled for the whole of `pending`, so it should cover every awaited step
// of the submit (uploads included), not just the final mutation; otherwise a
// second click starts the submit again.
export function SubmitButton({
  pending,
  pendingText,
  disabled,
  type = "submit",
  size = "sm",
  children,
  ...props
}: SubmitButtonProps) {
  return (
    <Button type={type} size={size} disabled={pending || disabled} {...props}>
      {pending ? (
        <>
          <Loader2 className="animate-spin" />
          {pendingText}
        </>
      ) : (
        children
      )}
    </Button>
  );
}
